import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import {
  isOcppLogCallResultMessageAuthorize,
  isOcppLogCallResultMessageBootNotification,
  isOcppLogCallResultMessageHeartbeat,
  isOcppLogCallResultMessageMeterValue,
  isOcppLogCallResultMessageRemoteStartTransaction,
  isOcppLogCallResultMessageRemoteStopTransaction,
  isOcppLogCallResultMessageStartTransaction,
  isOcppLogCallResultMessageStatusNotification,
  isOcppLogCallResultMessageStopTransaction,
  isOcppLogCallResultSendLocalList,
} from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import React, { useMemo } from 'react';

import { MeterValueLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/meter-value-log.component';
import { RemoteStartTransactionComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/remote-start-transaction.component';
import { RemoteStopTransactionComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/remote-stop-transaction.component';
import { SendLocalListLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/send-local-list-message-log.component';

import { AuthorizeLogComponent } from './authorize-log.component';
import { BootNotificationLogComponent } from './boot-notification-log.component';
import { DefaultLogComponent } from './default-log.component';
import { HeartbeatLogComponent } from './heartbeat-log.component';
import * as css from './log-item.module.scss';
import { StartTransactionComponent } from './start-transaction.component';
import { StatusNotificationLogComponent } from './status-notification-log.component';
import { StopTransactionLogComponent } from './stop-transaction-log.component';

interface LogItemProps {
  log: OcppLogMessageFormatted;
}

const LogItem: React.FC<LogItemProps> = ({ log }) => {
  const children = useMemo(() => {
    const { message } = log;

    if (isOcppLogCallResultMessageHeartbeat(message)) {
      return <HeartbeatLogComponent log={log} />;
    }
    if (isOcppLogCallResultMessageStartTransaction(message)) {
      return <StartTransactionComponent log={log} />;
    }
    if (isOcppLogCallResultMessageStopTransaction(message)) {
      return <StopTransactionLogComponent log={log} />;
    }
    if (isOcppLogCallResultMessageAuthorize(message)) {
      return <AuthorizeLogComponent log={log} />;
    }
    if (isOcppLogCallResultMessageStatusNotification(message)) {
      return <StatusNotificationLogComponent log={log} />;
    }
    if (isOcppLogCallResultMessageBootNotification(message)) {
      return <BootNotificationLogComponent log={log} />;
    }
    if (isOcppLogCallResultMessageRemoteStartTransaction(message)) {
      return <RemoteStartTransactionComponent log={log} />;
    }
    if (isOcppLogCallResultMessageRemoteStopTransaction(message)) {
      return <RemoteStopTransactionComponent log={log} />;
    }
    if (isOcppLogCallResultMessageMeterValue(message)) {
      return <MeterValueLogComponent log={log} />;
    }
    if (isOcppLogCallResultSendLocalList(message)) {
      return <SendLocalListLogComponent log={log} />;
    }

    return <DefaultLogComponent log={log} />;
  }, [log]);

  return <div className={css.logContainer}>{children}</div>;
};

export default LogItem;
